import { render } from "./SummaryBoxComponent.vue?vue&type=template&id=686e14d8"
import script from "./SummaryBoxComponent.vue?vue&type=script&lang=js"
export * from "./SummaryBoxComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\anygence\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__